import ReactGA from 'react-ga4';

export const initGA = () => {
 ReactGA.initialize('G-YS6GEFM9JR');
};

export const logPageView = () => {
 ReactGA.send('pageview');
};
